import React, { useContext, useEffect, useState } from 'react'
import './statistiquesAujourdhui.css'
import Label from '../../../svg/Label'
import { StatistiqueContext } from '../../../context/statistiqueContext/StatistiqueContext';
import ErrorComponent from '../../../components/errorComponent/ErrorComponent';
import LoadingComponent from '../../../components/loadingComponent/LoadingComponent';
import { getStatistiques } from '../../../context/statistiqueContext/apiCalls'
import { typeMovements, wilayas } from '../../../data';
import { AgenceContext } from '../../../context/agenceContext/AgenceContext';
import { getAgencesByWilaya } from '../../../context/agenceContext/apiCalls';
import { AuthContext } from '../../../context/authContext/AuthContext';

function StatistiquesAujourdhui() {
    const { dispatch, statistiques, isFetchingGet, errorGet } = useContext(StatistiqueContext);
    const { dispatch: dispatchAgence, agencesByWilaya } = useContext(AgenceContext);
    const { user } = useContext(AuthContext);
    const [movementByAgences, setMovementByAgences] = useState([]);

    useEffect(() => {
        getStatistiques(dispatch);
        getAgencesByWilaya(dispatchAgence);
    }, [])

    useEffect(() => {
        setMovementByAgences([]);
        if (statistiques.movementsAgences && statistiques.movementsAgences.length > 0) {
            let similarAgences = [];
            let allAgences = [];
            let agenceId = statistiques.movementsAgences[0]['AgenceId'];
            statistiques.movementsAgences.map((item, index) => {
                if (item.AgenceId === agenceId) {
                    similarAgences.push(item);
                } else {
                    agenceId = item.AgenceId;
                    allAgences.push(similarAgences);
                    similarAgences = [];
                    similarAgences.push(item);
                }

                // reach the end of loop
                if (index === statistiques.movementsAgences.length - 1) {
                    allAgences.push(similarAgences);
                }
            })
            setMovementByAgences(allAgences)
        }
    }, [statistiques])

    return (
        <div className='statistiques'>
            {
                errorGet ? <ErrorComponent error={errorGet} /> : (
                    isFetchingGet ? <LoadingComponent /> : (
                        <>
                            {/* Statistiques Globals */}
                            {/* <div className='statistiques-title'>
                                <Label widthSize="35px" heightSize='17px' />
                                <span>Statistiques Global :</span>
                            </div>
                            <div className='statistiques-boxes'>
                                <div className='statistiques-box'>
                                    <span className="statistiques-sub-title nwe">NWE</span>
                                    <div className="statistiques-sub-detail">
                                        <div>
                                            <span>Aujourdui'hui</span>
                                            <span>{statistiques.nweCountD}</span>
                                        </div>
                                        <div>
                                            <span>Mois En Cours</span>
                                            <span>{statistiques.nweCountM}</span>
                                        </div>
                                        <div>
                                            <span>Global</span>
                                            <span>{statistiques.nweCountG}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className='statistiques-box'>
                                    <span className="statistiques-sub-title livre">Livré</span>
                                    <div className="statistiques-sub-detail">
                                        <div>
                                            <span>Aujourdui'hui</span>
                                            <span>{statistiques.livreCountD}</span>
                                        </div>
                                        <div>
                                            <span>Mois En Cours</span>
                                            <span>{statistiques.livreCountM}</span>
                                        </div>
                                        <div>
                                            <span>Global</span>
                                            <span>{statistiques.livreCountG}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className='statistiques-box'>
                                    <span className="statistiques-sub-title retour">RETOUR</span>
                                    <div className="statistiques-sub-detail">
                                        <div>
                                            <span>Aujourdui'hui</span>
                                            <span>{statistiques.retourCountD}</span>
                                        </div>
                                        <div>
                                            <span>Mois En Cours</span>
                                            <span>{statistiques.retourCountM}</span>
                                        </div>
                                        <div>
                                            <span>Global</span>
                                            <span>{statistiques.retourCountG}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className='statistiques-box'>
                                    <span className="statistiques-sub-title annule">ANNULE</span>
                                    <div className="statistiques-sub-detail">
                                        <div>
                                            <span>Aujourdui'hui</span>
                                            <span>{statistiques.annulerCountD}</span>
                                        </div>
                                        <div>
                                            <span>Mois En Cours</span>
                                            <span>{statistiques.annulerCountM}</span>
                                        </div>
                                        <div>
                                            <span>Global</span>
                                            <span>{statistiques.annulerCountG}</span>
                                        </div>
                                    </div>
                                </div>
                            </div> */}

                            {/* Nombre d'Envois Par Action */}
                            {
                                (user.role === 1 || user.role === 2) && (
                                    <>
                                        <div className='statistiques-title'>
                                            <Label widthSize="35px" heightSize='17px' />
                                            <span>Nombre d'Envois Par Action :</span>
                                        </div>
                                        <div className='statistiques-boxes'>
                                            <div className='statistiques-box'>
                                                <span className="statistiques-sub-title preparation">Preparation</span>
                                                <div className="statistiques-sub-detail">
                                                    <div>
                                                        <span>Aujourdui'hui</span>
                                                        <span>
                                                            {
                                                                statistiques["envoisActionD"] && statistiques["envoisActionD"].filter(item => item.type === 10)[0]['countByAction']
                                                            }
                                                        </span>
                                                    </div>
                                                    <div>
                                                        <span>Mois En Cours</span>
                                                        <span>
                                                            {
                                                                statistiques["envoisActionM"] && statistiques["envoisActionM"].filter(item => item.type === 10)[0]['countByAction']
                                                            }
                                                        </span>
                                                    </div>
                                                    <div>
                                                        <span>Global</span>
                                                        <span>
                                                            {
                                                                statistiques["envoisActionG"] && statistiques["envoisActionG"].filter(item => item.type === 10)[0]['countByAction']
                                                            }
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='statistiques-box'>
                                                <span className="statistiques-sub-title ramassage">Ramassage</span>
                                                <div className="statistiques-sub-detail">
                                                    <div>
                                                        <span>Aujourdui'hui</span>
                                                        <span>
                                                            {
                                                                statistiques["envoisActionD"] && statistiques["envoisActionD"].filter(item => item.type === 1)[0]['countByAction']
                                                            }
                                                        </span>
                                                    </div>
                                                    <div>
                                                        <span>Mois En Cours</span>
                                                        <span>
                                                            {
                                                                statistiques["envoisActionM"] && statistiques["envoisActionM"].filter(item => item.type === 1)[0]['countByAction']
                                                            }
                                                        </span>
                                                    </div>
                                                    <div>
                                                        <span>Global</span>
                                                        <span>
                                                            {
                                                                statistiques["envoisActionG"] && statistiques["envoisActionG"].filter(item => item.type === 1)[0]['countByAction']
                                                            }
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='statistiques-box'>
                                                <span className="statistiques-sub-title reception-agence">Réception Agence</span>
                                                <div className="statistiques-sub-detail">
                                                    <div>
                                                        <span>Aujourdui'hui</span>
                                                        <span>
                                                            {
                                                                statistiques["envoisActionD"] && statistiques["envoisActionD"].filter(item => item.type === 8)[0]['countByAction']
                                                            }
                                                        </span>
                                                    </div>
                                                    <div>
                                                        <span>Mois En Cours</span>
                                                        <span>
                                                            {
                                                                statistiques["envoisActionM"] && statistiques["envoisActionM"].filter(item => item.type === 8)[0]['countByAction']
                                                            }
                                                        </span>
                                                    </div>
                                                    <div>
                                                        <span>Global</span>
                                                        <span>
                                                            {
                                                                statistiques["envoisActionG"] && statistiques["envoisActionG"].filter(item => item.type === 8)[0]['countByAction']
                                                            }
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='statistiques-box'>
                                                <span className="statistiques-sub-title depot-agence">Dépot Client</span>
                                                <div className="statistiques-sub-detail">
                                                    <div>
                                                        <span>Aujourdui'hui</span>
                                                        <span>
                                                            {
                                                                statistiques["envoisActionD"] && statistiques["envoisActionD"].filter(item => item.type === 2)[0]['countByAction']
                                                            }
                                                        </span>
                                                    </div>
                                                    <div>
                                                        <span>Mois En Cours</span>
                                                        <span>
                                                            {
                                                                statistiques["envoisActionM"] && statistiques["envoisActionM"].filter(item => item.type === 2)[0]['countByAction']
                                                            }
                                                        </span>
                                                    </div>
                                                    <div>
                                                        <span>Global</span>
                                                        <span>
                                                            {
                                                                statistiques["envoisActionG"] && statistiques["envoisActionG"].filter(item => item.type === 2)[0]['countByAction']
                                                            }
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='statistiques-box'>
                                                <span className="statistiques-sub-title acheminement-depart">Dispatch</span>
                                                <div className="statistiques-sub-detail">
                                                    <div>
                                                        <span>Aujourdui'hui</span>
                                                        <span>
                                                            {
                                                                statistiques["envoisActionD"] && statistiques["envoisActionD"].filter(item => item.type === 3)[0]['countByAction']
                                                            }
                                                        </span>
                                                    </div>
                                                    <div>
                                                        <span>Mois En Cours</span>
                                                        <span>
                                                            {
                                                                statistiques["envoisActionM"] && statistiques["envoisActionM"].filter(item => item.type === 3)[0]['countByAction']
                                                            }
                                                        </span>
                                                    </div>
                                                    <div>
                                                        <span>Global</span>
                                                        <span>
                                                            {
                                                                statistiques["envoisActionG"] && statistiques["envoisActionG"].filter(item => item.type === 3)[0]['countByAction']
                                                            }
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='statistiques-box'>
                                                <span className="statistiques-sub-title acheminement-arrive">Center</span>
                                                <div className="statistiques-sub-detail">
                                                    <div>
                                                        <span>Aujourdui'hui</span>
                                                        <span>
                                                            {
                                                                statistiques["envoisActionD"] && statistiques["envoisActionD"].filter(item => item.type === 4)[0]['countByAction']
                                                            }
                                                        </span>
                                                    </div>
                                                    <div>
                                                        <span>Mois En Cours</span>
                                                        <span>
                                                            {
                                                                statistiques["envoisActionM"] && statistiques["envoisActionM"].filter(item => item.type === 4)[0]['countByAction']
                                                            }
                                                        </span>
                                                    </div>
                                                    <div>
                                                        <span>Global</span>
                                                        <span>
                                                            {
                                                                statistiques["envoisActionG"] && statistiques["envoisActionG"].filter(item => item.type === 4)[0]['countByAction']
                                                            }
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='statistiques-box'>
                                                <span className="statistiques-sub-title stock-agence">Stock Agence</span>
                                                <div className="statistiques-sub-detail">
                                                    <div>
                                                        <span>Aujourdui'hui</span>
                                                        <span>
                                                            {
                                                                statistiques["envoisActionD"] && statistiques["envoisActionD"].filter(item => item.type === 9)[0]['countByAction']
                                                            }
                                                        </span>
                                                    </div>
                                                    <div>
                                                        <span>Mois En Cours</span>
                                                        <span>
                                                            {
                                                                statistiques["envoisActionM"] && statistiques["envoisActionM"].filter(item => item.type === 9)[0]['countByAction']
                                                            }
                                                        </span>
                                                    </div>
                                                    <div>
                                                        <span>Global</span>
                                                        <span>
                                                            {
                                                                statistiques["envoisActionG"] && statistiques["envoisActionG"].filter(item => item.type === 9)[0]['countByAction']
                                                            }
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                )
                            }

                            {/* Nombre d'Envois Par Wilaya */}
                            <div className='statistiques-title'>
                                <Label widthSize="35px" heightSize='17px' />
                                <span>Nombre d'Envois Par Wilaya :</span>
                            </div>
                            <div className='statistiques-boxes'>
                                {
                                    (statistiques.envoisWilayaG && statistiques.envoisWilayaG.length > 0) ? (
                                        statistiques.envoisWilayaG.map((wily, index) => (
                                            <div className='statistiques-box' key={index}>
                                                <span className="statistiques-sub-title" style={{ "background": "var(--main-color-2)" }}>{wilayas.filter(item => item.id === wily.wilayaDeparture)[0]['nom']}</span>
                                                <div className="statistiques-sub-detail">
                                                    <div>
                                                        <span>Aujourdui'hui</span>
                                                        <span>
                                                            {  // search this wilaya in envoisWilayaD
                                                                statistiques.envoisWilayaD && (
                                                                    statistiques.envoisWilayaD.filter(item => item.wilayaDeparture === wily.wilayaDeparture).length > 0 ?
                                                                        statistiques.envoisWilayaD.filter(item => item.wilayaDeparture === wily.wilayaDeparture)[0]['countByWilaya'] : 0
                                                                )
                                                            }
                                                        </span>
                                                    </div>
                                                    <div>
                                                        <span>Mois En Cours</span>
                                                        <span>
                                                            {  // search this wilaya in envoisWilayaM
                                                                statistiques.envoisWilayaM && (
                                                                    statistiques.envoisWilayaM.filter(item => item.wilayaDeparture === wily.wilayaDeparture).length > 0 ?
                                                                        statistiques.envoisWilayaM.filter(item => item.wilayaDeparture === wily.wilayaDeparture)[0]['countByWilaya'] : 0
                                                                )
                                                            }
                                                        </span>
                                                    </div>
                                                    <div>
                                                        <span>Global</span>
                                                        <span>
                                                            {
                                                                statistiques.envoisWilayaD ? (wily.countByWilaya) : 0
                                                            }
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    ) : <span className='no-data' style={{ "fontSize": "17px", "textAlign": "left" }}>Il n'y a pas encore de données</span>
                                }
                            </div>

                            {/* Movement Par Agence */}
                            <div className='statistiques-title'>
                                <Label widthSize="35px" heightSize='17px' />
                                <span>Movement Par Agence :</span>
                            </div>
                            <div className='statistiques-boxes'>
                                {
                                    (statistiques.movementsAgences && statistiques.movementsAgences.length > 0) ? (
                                        movementByAgences.map((mov, index) => (
                                            <div className='statistiques-box' style={{ "width": "370px" }} key={index}>
                                                <span className="statistiques-sub-title" style={{ "background": "var(--main-color-2)" }}>{agencesByWilaya.filter(item => item.id === mov[0].AgenceId)[0]['nom']}</span>
                                                <div className="statistiques-sub-detail">
                                                    {
                                                        mov.map((subMov, i) => (
                                                            <div key={i}>
                                                                <span>{typeMovements.filter(item => item.id === subMov.type)[0]['nom']}</span>
                                                                <span>{Number.parseFloat(subMov.sumByAgenceAndTypeMovement).toFixed(2)}</span>
                                                            </div>
                                                        ))
                                                    }
                                                </div>
                                            </div>
                                        ))
                                    ) : <span className='no-data' style={{ "fontSize": "17px", "textAlign": "left" }}>Il n'y a pas encore de données</span>
                                }
                            </div>
                        </>
                    )
                )
            }
        </div >
    )
}

export default StatistiquesAujourdhui